// extracted by mini-css-extract-plugin
export default {"tile":"CustomTile_tile__P+IDF"};